﻿import DKplanLogin from "../NIRAS/Login.js";
import News from "../NIRAS/News.js";
import "../NIRAS/API/API_Base.js";
import "../NIRAS/API/API_Newsfeed.js"

window.DKplanLogin = DKplanLogin;
window.News = News;